import React, { useContext, useState, useRef, useEffect } from "react";
import MyContext from "../../../context/MyContext";
import AuthContext from "../../../context/userAuth.context";
import SoundPlayer from "./soundComp";
import FreeSoundPlayer from "./playSoundComp";
import axios from "axios";
import swal from "sweetalert";
import TickerContext from "../../../context/ticker";
import TTS from "../../../TextToSpeech/TTS";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

export const SoundWrapper = (props) => {
  const { authenticationData, Role, Access, getLink } = useContext(AuthContext);
  const [ActiveTab, setActiveTab] = useState("Sound");
  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    calculateTimeByWidth,
    clone,
    SoundsData,
    setSoundsData,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    calculateWidthByDuration,
    ChangeCount,
    setChangeCount,
    Tl_TotalTime,
    CanvasDisplay,
    seteditableObject,
    setisTextInputOrAreaFocus,
  } = useContext(MyContext);

  const { TickerPosition } = useContext(TickerContext);

  const [UploadData, setUploadData] = useState(null);

  const [free, setfree] = useState(true);

  const [premium, setpremium] = useState(false);

  const [Uploads, setUploads] = useState(false);

  const [FreeSounds, setFreeSounds] = useState([]);

  const [PremiumSounds, setPremiumSounds] = useState([]);

  const [SoundUploads, setSoundUploads] = useState([]);

  const [isDone, setIsDone] = useState(false);

  const [userSounds, setUserSounds] = useState([]);

  const [adminSounds, setAdminSounds] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const SoundRef = useRef();

  const SoundUploading = (params) => {
    SoundRef.current.click();
  };

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const onInputClick = (event) => {
    event.target.value = "";
  };

  const fileChangeHandle = (e) => {
    var formdata = new FormData();

    for (var i = 0; i < e.target.files.length; i++) {
      formdata.append("NotPremium", e.target.files[i]);
    }

    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Character/UploadSounds",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${formdata._boundary}`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        if (response.data.type === "admin") {
          const DataArray = response.data.result;

          setSoundsData({
            userData: [],
            adminData: DataArray,
          });
        } else if (response.data.type === "user") {
          const DataArray = response.data.result;
          let array = clone(SoundsData);
          array.userData = DataArray;
          setSoundsData(array);
        }
        swal("Excellent", "Sound Has Been Uploaded", "success");
      })
      .catch((excetion) => {
        //console.log(excetion);
        swal("Failed", "Unable to Upload Sound. Please Try Again", "error");
      });
  };

  useEffect(() => {
    //if (SoundsData.adminData === null) {
    axios
      .get(authenticationData.ApiBaseURL + "/api/Character/GetSounds", {
        headers: {
          "Content-Type": `multipart/form-data`,
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((response) => {
        if (response.data.status === true) {
          if (response.data.type === "admin") {
            const DataArray = response.data.sounds;
            setAdminSounds(DataArray);
            setSoundsData({
              userData: [],
              adminData: DataArray,
            });
          } else if (response.data.type === "user") {
            const DataArray = response.data.sounds;

            if (
              response.data.userSounds != undefined &&
              response.data.userSounds != null
            ) {
              setSoundsData({
                userData: response.data.userSounds,
                adminData: DataArray,
              });
              setUserSounds(response.data.userSounds);
              setAdminSounds(DataArray);
            } else {
              setSoundsData({
                userData: [],
                adminData: DataArray,
              });
              setAdminSounds(DataArray);
            }
          }
        }
      })
      .catch((error) => {
        //console.log(error);
      });
    //  }
  }, []);

  useEffect(() => {
    if (SoundsData.adminData != null) {
      let prm = [];
      let fre = [];

      let DataArray = SoundsData.adminData;

      for (let i = 0; i < DataArray.length; i++) {
        // if (DataArray[i].isPremium === true) {
        //   prm.push(DataArray[i]);
        // }
        // else {
        if (
          DataArray[i].duration != null &&
          !DataArray[i].duration.toString().includes("0:0 minutes")
        )
          fre.push(DataArray[i]);
        //}
      }
      setFreeSounds(fre);
      //setPremiumSounds(prm);
      setSoundUploads(SoundsData.userData);
    }
  }, [SoundsData]);

  const [PlayerParent, setPlayerParent] = useState();

  useEffect(() => {
    if (UploadData != null) {
      onButtonClick();
    }
  }, [UploadData]);

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const onButtonClick = () => {


    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    var typelength = 1;
    var checkKey = 0;
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type === "audio") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }
    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
    let currTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);
    let _duration = calculateTimeByWidth(UploadData.time);
    let newEntryLayerData = {
      key: checkKey + 1,
      AnimationId: makeid(8),
      layerIndex: topIndex,
      type: "audio",
      bgColor: "#ffb568",
      Name: UploadData.name,
      path: UploadData.path,
      audioTime: UploadData.time,
      canvas: null,
      userFile: "xyz",
      index: null,
      TimelineZoom: timelineZoomVal,
      duration: UploadData.time,
      StartAudioTime: TickerPosition,
      startTime: currTime,
      endTime: calculateTimeByWidth(
        TickerPosition + calculateWidthByDuration(UploadData.time)
      ),
      volume: null,
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      audio_node: null,
      typeIcon: "audiotrack",
      Svglooping: false,
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      x: 0,
      y: 0,
      volume: 100,
      layerlock: false,
      opc: 1, //its use for the eye on the timeline wrapper for lock
      hidden: false,
      Editable: true,
      startPositionOnTimeline: TickerPosition,
      player: false,
      extendtoAllSlides: false,
      loop: false,
      fadeIn: 0,
      fadeOut: 0,
      Sound: UploadData.Sound,
    };
    //1px is equal to 13.28ms and 15.06px is 200ms so 1s equals to 75.30px so now calculate width based on duration
    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;

    setLayersData(LayersData.concat(newEntryLayerData));
    setChangeCount(ChangeCount + 1);

    seteditableObject({
      showPanel: true,
      editableItem: newEntryLayerData,
    });
  };

  const SearchAsset = () => {
    setSoundsData({
      userData: userSounds,
      adminData: adminSounds.filter((x) =>
        x.name.toLowerCase().includes(searchKeyword.toLowerCase())
      ),
    });
  };

  //const [time, settime] = useState();
  const [playing, setPlaying] = useState(false);
  const [pause, setPause] = useState(true);
  const [toggle, setToggle] = useState(false);
  const [currentPlayingAudio, setCurrentPlayingAudio] = useState(null);

  const PlayAudio = (path) => {
    if (!currentPlayingAudio) {
      var audio = new Audio(path);
      audio.id = path;
      setCurrentPlayingAudio(audio);
      audio.play();
    } else {
      currentPlayingAudio.src =
        props.authenticationData.ApiBaseURL + "/" + props.value.path;
      currentPlayingAudio.play();
    }
    //const toggle = (data) => setToggle(data);

    // useEffect(() => {
    //   playing ? audios.play() : audios.pause();
    // }, [playing]);

    // useEffect(() => {
    //   audios.addEventListener("ended", () => setPlaying(false));
    //   return () => {
    //     audios.removeEventListener("ended", () => setPlaying(false));
    //   };
    // }, []);
  };

  const PauseAudio = () => {
    if (currentPlayingAudio) {
      currentPlayingAudio.src = null;
      currentPlayingAudio.pause();
    }
  };

  useEffect(() => {
    PauseAudio();
  }, [pause]);

  var calculateSoundDuration = (url) =>
    new Promise((resolve, reject) => {
      let audio = document.createElement("audio");
      audio.id = url;
      audio.src = url;

      //var audio = document.getElementById('audio-1');
      audio.onloadedmetadata = function () {
        const date = new Date(null);
        date.setSeconds(Math.round(audio.duration)); // specify value for SECONDS here
        const result = date.toISOString().slice(11, 19);
        resolve(result + ":000");
        // var totalNumberOfSeconds = Math.round(audio.duration);
        // var hours = parseInt(totalNumberOfSeconds / 3600);
        // var minutes = parseInt((totalNumberOfSeconds - hours * 3600) / 60);
        // var seconds = Math.floor(
        //   totalNumberOfSeconds - (hours * 3600 + minutes * 60)
        // );
        // let result =
        //   (minutes < 10 ? "0" + minutes : minutes) +
        //   ":" +
        //   (seconds < 10 ? "0" + seconds : seconds);
        // //settime(result);
        // resolve(result);
      };
    });

  useEffect(() => {
    if (PlayerParent != null) {
      PlayAudio(value.path);
      if (PlayerParent != value.path) {
        if (playing) {
          setToggle(true);
        }
      }
    }
  }, [PlayerParent]);

  useEffect(() => {
    if (!CanvasDisplay) {
      if (playing) {
        toggle(false);
        //audio.currentTime = 0
      }
    }
  }, [CanvasDisplay]);

  const deleteUserSound = (id) => {
    swal({
      title: "Confirm delete audio?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result) {
        var data = new FormData();
        data.append("ttsId", id);
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .post(authenticationData.ApiBaseURL + "/api/TTS/DeleteTTS", data, {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          })
          .then((response) => {
            const DataArray = response.data.result;
            let array = clone(SoundsData);
            array.userData = DataArray;
            setSoundsData(array);
          });
      }
    });
  };

  const AddToLayer = (e, path, name, time, isPremium) => {
    if (Access === "FE" && isPremium) {
      Swal.fire({
        title: "Upgrade Required",
        html: `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
      return;
    } else {
      calculateSoundDuration(authenticationData.ApiBaseURL + "/" + path).then(
        (result) => {
          if (
            e.target.nodeName === "svg" ||
            e.target.nodeName === "path" ||
            e.target.nodeName === "BUTTON"
          )
            return;

          if (
            e.target.className != "SoundPlayBtn" &&
            e.target.className != "material-icons"
          ) {
            setUploadData({
              path: path,
              name: name,
              time: result,
              Sound: new Audio(authenticationData.ApiBaseURL + "/" + path),
            });
          }
        }
      );
    }
  };

  const columns = [
    {
      field: "path",
      headerName: "Play",
      width: 80,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="flex-row align-center" style={{ gap: "1px" }}>
          <FreeSoundPlayer
            Role={""}
            PlayerParent={PlayerParent}
            setPlayerParent={setPlayerParent}
            value={{
              path: params.value,
              id: params.id,
              isPremium: params.row.isPremium,
            }}
            authenticationData={authenticationData}
            setUploadData={setUploadData}
            playState={CanvasDisplay}
          />
          {Access === "FE" && params.row.isPremium ? (
            <img
              style={{
                width: "15px",
                height: "15px",
              }}
              src="../AppIcons/IconsAll/PremiumIcon.svg"
              alt=""
            />
          ) : (
            <img
              style={{
                position: "relative",
                borderColor: "transparent",
              }}
              alt=""
            />
          )}
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      filterable: true,
      width: 140,
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              fontSize: "11px",
              fontWeight: "bold",
              textAlign: "start",
            }}
            id={params.id}
            onClick={(event) => {
              // if (Access === "FE" && params.row.isPremium) {
              //   Swal.fire({
              //     title: "Upgrade Required",
              //     html: `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
              //     icon: "info",
              //     cancelButtonColor: "#d33",
              //     backdrop: null,
              //   });
              //   return;
              // }
              // AddToLayer(
              //   event,
              //   params.row.path,
              //   params.value,
              //   params.row.duration
              // );
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration",
      width: 100,
      sortComparator: (v1, v2) => {
        const convertToMinutes = (timeStr) => {
          const [hours, minutes] = timeStr.split(":").map(Number);
          return hours * 60 + minutes;
        };

        const minutes1 = convertToMinutes(v1.replace(" minutes", ""));
        const minutes2 = convertToMinutes(v2.replace(" minutes", ""));

        return minutes1 - minutes2;
      },
      renderCell: (params) => {
        return (
          <div
            id={params.id}
            style={{
              fontSize: "11px",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
  ];

  const columns2 = [
    {
      field: "path",
      headerName: "Play",
      width: 30,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="flex-row align-center" style={{ gap: "1px" }}>
          <FreeSoundPlayer
            Role={""}
            PlayerParent={PlayerParent}
            setPlayerParent={setPlayerParent}
            value={{
              path: params.value,
              id: params.id,
              isPremium: params.row.isPremium,
            }}
            authenticationData={authenticationData}
            setUploadData={setUploadData}
            playState={CanvasDisplay}
          />
          {Access === "FE" && params.row.isPremium ? (
            <img
              style={{
                width: "15px",
                height: "15px",
              }}
              src="../AppIcons/IconsAll/PremiumIcon.svg"
              alt=""
            />
          ) : (
            <img
              style={{
                position: "relative",
                borderColor: "transparent",
              }}
              alt=""
            />
          )}
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      filterable: true,
      width: 140,
      renderCell: (params) => {
        return (
          <div className="sound-name-date" id={params.id}>
            <div style={{ fontWeight: "bold" }}> {params.value}</div>
            <div> {params.row.createdDate}</div>
          </div>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration",
      width: 80,
      sortComparator: (v1, v2) => {
        const convertToMinutes = (timeStr) => {
          const [hours, minutes] = timeStr.split(":").map(Number);
          return hours * 60 + minutes;
        };

        const minutes1 = convertToMinutes(v1.replace(" minutes", ""));
        const minutes2 = convertToMinutes(v2.replace(" minutes", ""));

        return minutes1 - minutes2;
      },
      renderCell: (params) => {
        return (
          <div
            id={params.id}
            style={{
              fontSize: "11px",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <IconButton
            size="small"
            onClick={() => deleteUserSound(params.row.id)}
            aria-label="delete"
          >
            <DeleteIcon size="small" style={{ fontSize: "16px" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <div className="innerWrapperPanel">
      <div className="templatesWrapper">
        <div className="divLabel mb-3">Sound</div>

        <div key={`Tabmenu-1`} className="tabs mb-3">
          <div className="p2">
            <div
              className={"tabButton" + (free ? " activeTab" : "")}
              onClick={() => {
                setfree(true);
                setpremium(false);
                setUploads(false);

                setActiveTab("Sound");
              }}
            >
              Sounds
            </div>
            <div
              className={"tabButton" + (!free && !Uploads ? " activeTab" : "")}
              onClick={() => {
                setfree(false);
                setpremium(true);
                setUploads(false);
                setActiveTab("TTS");
              }}
              style={{ position: "relative" }}
            >
              Text to Speech
            </div>
            <div
              className={"tabButton" + (!free && !premium ? " activeTab" : "")}
              onClick={() => {
                setfree(false);
                setpremium(false);
                setUploads(true);

                setActiveTab("Uploads");
              }}
            >
              Uploads
            </div>
          </div>
        </div>

        {/* {ActiveTab === "Sound" && (
          <div className="searchBarParent" style={{ padding: "0px 12px" }}>
            <span className="material-icons SearchIconCustom">search</span>
            <input
              multiple
              type="text"
              onKeyUp={(e) => SearchAsset(e)}
              value={searchKeyword}
              onChange={(e) => {
                setSearchKeyword(e.target.value);
              }}
              onFocus={() => setisTextInputOrAreaFocus(true)}
              onBlur={() => setisTextInputOrAreaFocus(false)}
              className="search customInput searchpad"
              placeholder="Search Here ..."
            />
          </div>
        )} */}

        <div
          className="style-1"
          style={{
            width: "100%",
            height: "calc(100% - 124px)",
            overflowY: "scroll",
          }}
        >
          {SoundsData && (
            <div className="p2">
              {free && (
                <>
                  {/* {FreeSounds.map((value, index) => (
                    <SoundPlayer
                      Role={""}
                      time={value.duration}
                      key={"FreeSounds" + index}
                      PlayerParent={PlayerParent}
                      setPlayerParent={setPlayerParent}
                      value={value}
                      authenticationData={authenticationData}
                      setUploadData={setUploadData}
                      playState={CanvasDisplay}
                    />
                  ))} */}
                  {/* {formatData?.length ?  */}
                  {/* <div style={{ height: 400, width: '100%' }}>
                    <DataGrid
                      {...columns}
                      // sortModel={sortModel}
                      // onSortModelChange={(model) => setSortModel(model)}
                    />
                  </div> */}
                  {/* :null} */}
                  <div className="App">
                    <DataGrid
                      rows={FreeSounds}
                      columns={columns}
                      pageSizeOptions={[5]}
                      disableRowSelectionOnClick
                      onRowClick={(params, event) => {
                        if (!event.ignore) {
                          AddToLayer(
                            event,
                            params.row.path,
                            params.row.name,
                            params.row.duration,
                            params.row.isPremium
                          );
                        }
                      }}
                    />
                  </div>
                </>
              )}

              {premium && (
                <>
                  {/* {PremiumSounds.map((value, index) =>
                (<SoundPlayer key={('PremiumSounds' + index)} PlayerParent={PlayerParent} setPlayerParent={setPlayerParent} value={value} authenticationData={authenticationData}
                  setUploadData={setUploadData} playState={CanvasDisplay}
                />)
                )} */}

                  <TTS isDone={isDone} setIsDone={setIsDone} />
                </>
              )}

              {Uploads === true && (
                <>
                  <div
                    className="image_uploader"
                    style={{ marginBottom: "5px" }}
                  >
                    <div
                      onClick={SoundUploading}
                      className="image_uploader_inner"
                    >
                      <div className="Image_uploader_text">
                        <div>Upload Sounds</div>

                        <input
                          ref={SoundRef}
                          accept=".mp3"
                          type="file"
                          hidden
                          onClick={onInputClick}
                          onChange={fileChangeHandle}
                          multiple
                        />
                      </div>
                    </div>
                  </div>
                  <div className="App">
                    <DataGrid
                      rows={SoundUploads}
                      columns={columns2}
                      pageSizeOptions={[5]}
                      disableRowSelectionOnClick
                      onRowClick={(params, event) => {
                        if (!event.ignore) {
                          AddToLayer(
                            event,
                            params.row.path,
                            params.row.name,
                            params.row.duration,
                            params.row.isPremium
                          );
                        }
                      }}
                    />
                  </div>
                  {/* <div
                    key={"SoundUp-1"}
                    className="image_uploader"
                    style={{ marginBottom: "5px" }}
                  >
                    <div
                      onClick={SoundUploading}
                      className="image_uploader_inner"
                    >
                      <div className="Image_uploader_text">
                        <div>Upload Sounds</div>

                        <input
                          ref={SoundRef}
                          accept=".mp3"
                          type="file"
                          hidden
                          onClick={onInputClick}
                          onChange={fileChangeHandle}
                          multiple
                        />
                      </div>
                    </div>
                  </div>
                  {SoundUploads.map((value, index) => (
                    <SoundPlayer
                      time={value.duration}
                      clone={clone}
                      setSoundsData={setSoundsData}
                      SoundsData={SoundsData}
                      key={"SoundUploads" + index}
                      Role={Role}
                      PlayerParent={PlayerParent}
                      setPlayerParent={setPlayerParent}
                      value={value}
                      authenticationData={authenticationData}
                      setUploadData={setUploadData}
                    />
                  ))} */}
                </>
              )}
            </div>
          )}
        </div>

        {/* 
        <div className='image_uploader'
          style={{
            position: 'relative',
          }}
        >
          <div onClick={() => onButtonClick()} className='image_uploader_inner'>

            <div className='image_uploader_icon_container'>

              <span className="material-icons" style={{ color: '#286aff' }}>
                headphones
              </span>

            </div>

            <div className='Image_uploader_text'>
              <div>Add new sound </div>
            </div>

          </div>
        </div> */}
      </div>
    </div>
  );
};
export default SoundWrapper;
